import { addEvents } from '../../helpers/dom/addEvents';
import { ancestorBySelector } from '../../helpers/element/findAncestor';

class InputLabel {
    constructor(elem) {
        this.input = elem;
        this.parent = null;

        this.getElements();
        this.setEvents();
        this.checkInput();
    }

    getElements() {
        this.parent = ancestorBySelector(this.input, '.form-row');
    }
    setEvents() {
        addEvents(this.input, ['keydown', 'keyup'], () => {
            this.checkInput(this.input);
        });

        addEvents(this.input, ['focus'], () => {
            this.parent.classList.add('has-focus');
        });

        addEvents(this.input, ['blur'], () => {
            this.parent.classList.remove('has-focus');
        });
    }

    checkInput() {
        if (this.input.value.length > 0 || this.input.value !== this.input.defaultValue) {
            this.parent.classList.add('is-filled');
        } else {
            this.parent.classList.remove('is-filled');
        }
    }
}

export function initCheckoutInputLabels() {
    const text = document.querySelectorAll('.form-row input[type=text]');
    const email = document.querySelectorAll('.form-row input[type=email]');
    const tel = document.querySelectorAll('.form-row input[type=tel]');

    const inputs = [...text, ...email, ...tel];

    if (inputs.length > 0) {
        inputs.forEach((input) => {
            new InputLabel(input);
        });
    }
};

